module.exports = __webpack_public_path__ + "media/images/sports_icons/pickleball-5b3e9b222d6085302981f9696ca6491f.png";